// İSG uzmanı portalı — Ziyaretçi (Visits) TanStack Query anahtarları (api-contract
// §11, tenant-scoped). Liste anahtarları parametreleri içerir (durum/saha/şube/tarih/
// arama/sayfa değişince yeniden çeker); invalidasyon önek (prefix) ile yapılır:
// `['visits','list']` tüm ziyaret listesi sorgularını (sahada + geçmiş) kapsar.
//
// Ayarlar (§10) / Admin (§9) anahtarlarından AYRIDIR — Ziyaretçi tek firmaya kapsanmış
// tenant iş modülüdür.

import type { VisitListParams } from '@isgportal/shared';

export const visitsKeys = {
  /** Tüm ziyaret listesi sorgularının öneki (sahada + geçmiş) — invalidasyon için. */
  list: () => ['visits', 'list'] as const,
  /** "Şu an sahada" (acil durum ekranı) — `status=OnSite` sabit; sayfa parametreli. */
  onSite: (params: VisitListParams) => ['visits', 'list', 'onSite', params] as const,
  /** Ziyaret geçmişi/rapor — tüm durumlar + filtreler. */
  history: (params: VisitListParams) => ['visits', 'list', 'history', params] as const,
  /** Tek ziyaret detayı. */
  detail: (uuid: string) => ['visits', 'detail', uuid] as const,
  /** Güvenlik brifing (firma tekil) — erişim sondası (gate) ile PAYLAŞILIR (tek istek). */
  safetyBriefing: () => ['visits', 'safety-briefing'] as const,
} as const;
